
import {translate} from '@elements/translations';
import {defineComponent} from 'vue';
import {useTicketStore} from '~vue/stores/TicketStore.ts';
import {storeToRefs} from 'pinia'

export default defineComponent({
    name: 'CalendarLegend',
    props: {
    },
    setup(props, {emit}) {
        const ticketStore = useTicketStore();
        const {
            type,
            hasCalendarView
        } = storeToRefs(ticketStore);
        return {
            translate,
            type,
            hasCalendarView
        }
    }
});
